/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetMediaOriginsResponse } from '../../models/get-media-origins-response';

export interface MediaServiceGetMediaOrigins$Params {
}

export function mediaServiceGetMediaOrigins(http: HttpClient, rootUrl: string, params?: MediaServiceGetMediaOrigins$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMediaOriginsResponse>> {
  const rb = new RequestBuilder(rootUrl, mediaServiceGetMediaOrigins.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetMediaOriginsResponse>;
    })
  );
}

mediaServiceGetMediaOrigins.PATH = '/api/v3/gateway/media/origins';
